import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../../api/config";
import { HTTP_STATUS } from "../../../app/constants";

const namespace = "collectionreport";

const initialState = {
  loading: null,
  collectionReportList: [],
  errorMessage: "",
};

//GET
export const getCollectionDetailsFromServer = createAsyncThunk(
  `${namespace}/getCollectionDetailsFromServer`,
  async (record, { rejectWithValue }) => {
    try {
      const response = await api.get(
        `/collectiondetailsforcollectionreport?customercode=${record.customerCode}&fromdate=${record.selectedFromDate}&todate=${record.selectedToDate}`,
        {
          headers: { auth: `${JSON.parse(sessionStorage.getItem("auth"))}` },
        }
      );
      return response.data;
    } catch (err) {
      if (err.response) {
        return err.response.data;
      } else {
        return rejectWithValue({
          message: "Network error or server not reachable",
        });
      }
    }
  }
);

// GET
export const getCollectionDetailsFromServerByPagination = createAsyncThunk(
  `${namespace}/getCollectionDetailsFromServerByPagination`,
  async (records, { rejectWithValue }) => {
    try {
      const response = await api.get(
        `/collectionreportpagination?customercode=${records.record.customerCode}&fromdate=${records.record.selectedFromDate}&todate=${records.record.selectedToDate}&pageno=${records.pageNo}&rowsize=${records.rowSize}`,
        {
          headers: { auth: `${JSON.parse(sessionStorage.getItem("auth"))}` },
        }
      );
      return response.data;
    } catch (err) {
      if (err.response) {
        return err.response.data;
      } else {
        return rejectWithValue({
          message: "Network error or server not reachable",
        });
      }
    }
  }
);

export const getCollectionsCountFromServer = createAsyncThunk(
  `${namespace}/getCollectionsCountFromServer`,
  async (record, { rejectWithValue }) => {
    try {
      const response = await api.get(
        `/collectionsCount?customercode=${record.customerCode}&fromdate=${record.selectedFromDate}&todate=${record.selectedToDate}`,
        {
          headers: { auth: `${JSON.parse(sessionStorage.getItem("auth"))}` },
        }
      );
      return response.data;
    } catch (err) {
      if (err.response) {
        return err.response.data;
      } else {
        return rejectWithValue({
          message: "Network error or server not reachable",
        });
      }
    }
  }
);

export const collectionReportSlice = createSlice({
  name: namespace,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCollectionDetailsFromServer.pending, (state) => {
        state.loading = HTTP_STATUS.PENDING;
      })
      .addCase(getCollectionDetailsFromServer.fulfilled, (state, action) => {
        state.loading = HTTP_STATUS.FULFILLED;
        state.collectionReportList = action.payload.data;
        state.errorMessage = null;
      })
      .addCase(getCollectionDetailsFromServer.rejected, (state, { error }) => {
        state.loading = HTTP_STATUS.REJECTED;
        state.errorMessage = error.errorMessage;
      })
      .addCase(getCollectionDetailsFromServerByPagination.pending, (state) => {
        state.loading = HTTP_STATUS.PENDING;
      })
      .addCase(
        getCollectionDetailsFromServerByPagination.fulfilled,
        (state, action) => {
          state.loading = HTTP_STATUS.FULFILLED;
          state.collectionReportList = action.payload.data;
          state.errorMessage = null;
        }
      )
      .addCase(
        getCollectionDetailsFromServerByPagination.rejected,
        (state, { error }) => {
          state.loading = HTTP_STATUS.REJECTED;
          state.collectionReportList = [];
          state.errorMessage = error.message;
        }
      );
    // .addCase(
    //   getSalesDetailsforSalesReportThermalPrintFromServer.pending,
    //   (state) => {
    //     state.loading = HTTP_STATUS.PENDING;
    //   }
    // )
    // .addCase(
    //   getSalesDetailsforSalesReportThermalPrintFromServer.fulfilled,
    //   (state, action) => {
    //     state.loading = HTTP_STATUS.FULFILLED;
    //     state.errorMessage = null;
    //   }
    // )
    // .addCase(
    //   getSalesDetailsforSalesReportThermalPrintFromServer.rejected,
    //   (state, { error }) => {
    //     state.loading = HTTP_STATUS.REJECTED;
    //     state.errorMessage = error.errorMessage;
    //   }
    // );
  },
});

export const selectLoadingStatus = (state) => state.collectionsreport.loading;
export default collectionReportSlice.reducer;
